export default __webpack_public_path__ + "static/summer_containers53-83a13b3be81b21489ca3c0805e0bf871.webp";